export function errorFactory(name, defaultMessage) {
  const customError = function (message) {
    this.name = name;
    this.message = message || defaultMessage;
    this.stack = (new Error()).stack;
  };

  customError.prototype = Object.create(customError.prototype);
  customError.prototype.constructor = customError;

  return customError;
}

export const InvalidArgumentError = errorFactory('InvalidArgumentError', 'Invalid argument passed to function');

